export default "__VITE_ASSET__Cd2i43YN__"